module.exports = __webpack_public_path__ + "static/header-5cd49e19d6fcf4f1bd91565c184784ae.png";